import { gql } from "@apollo/client";

export const GET_IMAGE_LIBRARY_ITEMS = gql`
  query image_library($where: image_library_bool_exp) {
    image_library(where: $where, order_by: { display_name: asc }) {
      id
      image_base64
      organization_id
      display_name
      caption
      updated_at
      created_at
      is_active
      user {
        username
      }
    }
  }
`;

export const GET_IMAGE_LIBRARY = gql`
  query GetImageLibrary($id: Int!) {
    image_library_by_pk(id: $id) {
      id
      image_base64
      organization_id
      display_name
      caption
      updated_at
      created_at
      is_active
      user {
        username
      }
    }
  }
`;

export const GET_IMAGE_LIBRARY_ITEMS_LIMITED = gql`
  query image_library($where: image_library_bool_exp) {
    image_library(where: $where, order_by: { display_name: asc }) {
      image_base64
      display_name
    }
  }
`;
